export class Contact {
  constructor(
    public name: string,
    public href: string,
    public app: string,
    public icon: string,
  ) {}
}
